<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getUsers"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:header-buttons> </template>

      <template v-slot:headings>
        <div class="col-md-1"></div>
        <div class="col-md-2">Name</div>
        <div class="col-md-4">Email</div>
        <div class="col-md-3">Roles</div>
        <div class="col-md-2 text-left text-md-right">Action</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-1">
          <v-lazy-image
            v-if="slotProps.item.image"
            :src="slotProps.item.image"
            class="img-fluid maxHeight50"
          />
        </div>
        <div class="col-md-2 my-auto">
          <p class="m-0 font-weight-bold">{{ slotProps.item.name }}</p>
        </div>

        <div class="col-md-4 my-auto">
          <p class="m-0">{{ slotProps.item.email }}</p>
        </div>

        <div class="col-md-3 my-auto">
          <b-badge
            class="mb-1 mr-1"
            variant="warning"
            v-for="role in slotProps.item.roles"
            :key="role.id"
            >{{ role.role }}</b-badge
          >
        </div>

        <div class="col-md-2 my-auto text-left text-md-right pt-3 pt-md-0">
          <router-link
            v-b-tooltip.hover
            title="view"
            :to="{ name: 'user-logs-show', params: { id: slotProps.item.id } }"
            class="text-info table-action-icon"
          >
            <i class="lni lni-search-alt"></i>
          </router-link>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import userLogRepo from "@/api/repos/userLogRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "name", label: "Name Asc", order: "asc" },
      sortOptions: [
        { column: "name", label: "Name Asc", order: "asc" },
        { column: "name", label: "Name Desc", order: "desc" },
        { column: "created_at", label: "Newest", order: "asc" },
        { column: "created_at", label: "Oldest", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getUsers({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      search: "",
    });
  },
  methods: {
    async getUsers(e) {
      this.isLoad = true;
      try {
        let { data } = await userLogRepo.users(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.users.data;
        this.totalRows = data.users.total;
        this.page = data.users.current_page;
        this.fromRow = data.users.from;
        this.toRow = data.users.to;
        this.lastPage = data.users.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },
  },

  watch: {
    search() {
      this.searchQuery();
    },
  },
};
</script>
